export default "__VITE_ASSET__BRz5Hb1L__"